// extracted by mini-css-extract-plugin
module.exports = {"header":"Header-module--header--1Op28","Applogo":"Header-module--Applogo--1q_sx"};